import dateMappings from '../../utils/dateParts';

export const getRelevantMonthsFromArch = ({ minMonth, maxMonth }) => {
  const relevantMonths = [];
  Object.entries(dateMappings).forEach(([key, value]) => {
    if (
      value.index >= dateMappings[minMonth]?.index
      && value.index <= dateMappings[maxMonth]?.index
    ) {
      relevantMonths.push(key);
    }
  });

  return relevantMonths;
};

export const boolToNumber = (bool) => (bool ? 1 : 0);
